import { TokenRequestSM } from "../service-models/token/token-request-s-m";
import {  BaseViewModel } from "./base.viewmodel";

export class LoginViewModel implements BaseViewModel {
    PageTitle: string = 'Login';
    tokenRequest: TokenRequestSM = new TokenRequestSM();
    rememberMe: boolean = false;
    hide: boolean = true;
    eyeDefault = 'default';

    constructor() {
        // super();
        // this.addValidations();
    }

    // addValidations() {
    //     this.validationMessages.push(
    //         {
    //             errorMessage: 'Enter your login Id',
    //             errorType: ErrType.Required,
    //             isError: false,
    //             propertyName: 'loginId',
    //             propertyType: ''
    //         },
    //         {
    //             errorMessage: 'Please enter your password',
    //             errorType: ErrType.Required,
    //             isError: false,
    //             propertyName: 'password',
    //             propertyType: ''
    //         },
    //         {
    //             errorMessage: 'Please enter  valid email',
    //             errorType: ErrType.Pattern,
    //             isError: false,
    //             propertyName: 'loginId',
    //             propertyType:('^[a-zA-Z0-9][a-zA-Z0-9._-]+@[a-zA-Z.0-9-]+\\.[a-zA-Z]{2,3}$')
    //         },

    //     )
    // }

}